import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Tooltip } from "reactstrap";
import { Form, Formik } from "formik";
import information from "web/assets/images/informationIcon.png";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import UpgradeGuestSubscription from "web/components/UpgradeGuestSubscription";
import { paymentMethod, defaultPayment } from "redux/actions/payment";
import AlertModal from "web/components/AlertModal";

import styled from "styled-components";
import PaymentTabs from "./PaymentTab";
import BankACForm from "./BankACForm/index";
import DebitCreditCard from "./DebitCreditCard/index";

import { fetchLanguageContentNew } from "redux/actions/language";

const PaymentDetail = ({ pageData, fetchManageAccountPageData, ...props }) => {
  const [response, setResponse] = useState(undefined);
  const dispatch = useDispatch();
  let history = useHistory();
  const myRef = useRef(null);
  const token = localStorage.getItem("token");

  const storedData = useSelector((state) => state.storedData.payload);
  let disableFlg = storedData?.guestUser

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");

  const [brokerAcState, setBokerAcState] = useState(false);
  const [selectProfile, setSelectProfile] = useState();

  const [addBankCardmodal, setAddBankCardmodal] = useState(false);
  const addBankCardToggleModal = () => setAddBankCardmodal(!addBankCardmodal);

  const [addDebitCreditCardmodal, setAddDebitCreditCardmodal] = useState(false);
  const addDebitCreditToggleModal = () =>
    setAddDebitCreditCardmodal(!addDebitCreditCardmodal);

  const executeScroll = () => myRef.current.scrollIntoView(); // run this function from an event handler or pass it to useEffect to execute scroll

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();

  useEffect(() => {
    if (languageContentNew?.H8_Nav_Payment_Page) setPageLanguageContents(languageContentNew.H8_Nav_Payment_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  const toggleModal = () => setModal(!modal);

  useEffect(() => {
    if (pageData) {
      localStorage.setItem('taxId', pageData?.userDetails?.tax ?? "");
      localStorage.setItem('drivingLicense', pageData?.userDetails?.license ?? "");
      localStorage.setItem('dob', pageData?.userDetails?.dob ?? '');
      localStorage.setItem('firstName', pageData?.userDetails?.userName)
      localStorage.setItem('lastName', pageData?.userDetails?.userName)
      localStorage.setItem('userName', pageData?.userDetails?.userName)
      localStorage.setItem('companyName', pageData?.userDetails?.companyName)
      localStorage.setItem('uploadImage', pageData?.userDetails?.uploadImage)

      if (pageData?.userDetails?.userRole === 'BUYSELL' || pageData?.userDetails?.userRole === 'BROKER') localStorage.setItem("accountType", "Both")
      else if (pageData?.userDetails?.userRole === 'BUYER') localStorage.setItem("accountType", "Buyer")
      else if (pageData?.userDetails?.userRole === 'SELLER') localStorage.setItem("accountType", "Seller")
      else if (pageData?.userDetails?.userRole === 'GUEST') localStorage.setItem("accountType", "Guest")
    }
  }, [pageData]);

  const callBackFetch = () => {
    fetchManageAccountPageData()
  };

  const defaultPaymentAPI = async (id) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      let response = await dispatch(defaultPayment(id, token));
      if (response.status === "SUCCESS") {
        callBackFetch()
        setModalContent(response.message);
        setModalLink("");
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const [tooltipOpenProfile, setTooltipOpenProfile] = useState(false);
  const iIcon = (infoTxt) => {
    return (
      <>
        <img
          id="TooltipProfile"
          src={information}
          alt="TooltipProfile"
          style={{
            paddingLeft: "5px",
            position: "relative",
            top: "-1px",
          }}
        />
        <Tooltip
          placement="right"
          isOpen={tooltipOpenProfile}
          target="TooltipProfile"
          toggle={() => setTooltipOpenProfile(!tooltipOpenProfile)}
        >
          {infoTxt}
        </Tooltip>
      </>
    );
  };
  let brokerAccount = localStorage.getItem("brokerAccount");

  const getInitialValues = (pageData) => {
    return {
      buyerChk: (pageData?.userDetails?.userRole === 'BUYER' || pageData?.userDetails?.userRole === 'BUYSELL') ? true : false,
      sellerChk: (pageData?.userDetails?.userRole === 'SELLER' || pageData?.userDetails?.userRole === 'BUYSELL') ? true : false,
      resellerBroker: (pageData?.userDetails?.userRole === 'BROKER') ? true : false,
    };
  };
  return (
    <>
      <Container>
        <Wrapper>
          
          
          {pageData?.userDetails?.userRole === 'GUEST' ? <><div></div> <div
            ref={myRef}
            className="section-wrapper"           
          >
            <div class="community-details-header seller">
              <div class="community-name">
                <h4>
                  Profile Type
                  {brokerAccount === "brokerAc" &&
                    iIcon(
                      "Brokers and asset-based buyers and sellers will need to maintain separate accounts. If you would like to register as an asset-based buyer, seller, or both, please request a new account by completing a new registration form."
                    )}
                  {brokerAccount !== "brokerAc" && pageData?.userDetails?.userRole !== 'GUEST' &&
                    iIcon(
                      "This section shows if you are registered as a buyer, seller, or both. To register as an additional account type, please check the box to complete setup. If you wish to register as a broker, please request a new account by completing a new registration form."
                    )}
                    {pageData?.userDetails?.userRole === 'GUEST' &&
                    iIcon(
                      "This account is registered as a guest. Upgrade to a member in the Manage Subscription section below."
                    )}
                </h4>
              </div>
            </div>
            <ProfileType>
              {pageData && (
                <Formik
                  initialValues={getInitialValues(pageData)}
                  onSubmit={(values) => { }}
                >
                  {(props) => {
                    const {
                      isValid,
                      dirty,
                      values,
                      errors,
                      touched,
                      setFieldValue,
                    } = props;
                    return (
                      <>
                        <Form>
                          <div style={{ display: "flex", "flex-wrap": "wrap" }}>
                            {pageData?.userDetails?.userRole !== 'BROKER' && (
                              <>{pageData?.userDetails?.userRole !== 'GUEST' ? <>
                                <div style={{ "margin-right": "20px" }}>
                                  <CheckboxInput
                                    name="buyerChk"
                                    label="Buyer"
                                    disabled={pageData?.userDetails?.userRole === 'BUYER' || pageData?.userDetails?.userRole === 'BUYSELL' || pageData?.userDetails?.locationType === 'DEP' || pageData?.userDetails?.locationType === 'INDEPENDENT'}
                                    handleSelect={(name, label, e) => {
                                      setSelectProfile("Buyer");
                                      addDebitCreditToggleModal();
                                    }}
                                  />
                                </div>
                                <div style={{ "margin-right": "20px" }}>
                                  <CheckboxInput
                                    name="sellerChk"
                                    label="Seller"
                                    disabled={pageData?.userDetails?.userRole === 'SELLER' || pageData?.userDetails?.userRole === 'BUYSELL' || pageData?.userDetails?.locationType === 'DEP' || pageData?.userDetails?.locationType === 'INDEPENDENT'}
                                    handleSelect={(name, label, e) => {
                                      addBankCardToggleModal();
                                      setSelectProfile("Seller");
                                    }}
                                  />
                                </div>
                              </> : <>
                                <div style={{ "margin-right": "20px" }}>
                                  <CheckboxInput
                                    name="buyerChk"
                                    // label="Guest Member"
                                    label="Guest"
                                    disabled={true}
                                    checked={true}
                                    handleSelect={(name, label, e) => {
                                    }}
                                  />
                                </div>
                              </>}

                              </>
                            )}
                            {pageData?.userDetails?.userRole === 'BROKER' && (
                              <div style={{ "margin-right": "20px" }}>
                                <CheckboxInput
                                  name="resellerBroker"
                                  label="Broker"
                                  disabled={true}
                                  handleSelect={(name, label, e) => {
                                    setBokerAcState(true);
                                    setSelectProfile("Broker");
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          {addDebitCreditCardmodal &&
                            <DebitCreditCard
                              isOpen={addDebitCreditCardmodal}
                              toggle={addDebitCreditToggleModal}
                              modalType='sellerToBothBuySellConversion'
                              pageData={pageData}
                              type="profile"
                              onClickHander={(val) => {
                                if (val === "close") {
                                  if (selectProfile === "Buyer")
                                    setFieldValue("buyerChk", false);

                                  if (selectProfile === "Seller")
                                    setFieldValue("sellerChk", false);

                                  if (selectProfile === "Broker")
                                    setFieldValue("resellerBroker", false);
                                }
                                callBackFetch()
                                addDebitCreditToggleModal();
                              }}
                            />
                          }
                          {addBankCardmodal &&
                            <BankACForm
                              isOpen={addBankCardmodal}
                              modalType='buyerToBothBuySellConversion'
                              toggle={addBankCardToggleModal}
                              title=""
                              pageData={pageData}
                              callBackModal={() => {
                                addBankCardToggleModal();
                              }}
                              onClickHander={(val) => {
                                callBackFetch()
                                if (val === "close") {
                                  if (selectProfile === "Buyer")
                                    setFieldValue("buyerChk", false);

                                  if (selectProfile === "Seller")
                                    setFieldValue("sellerChk", false);

                                  if (selectProfile === "Broker")
                                    setFieldValue("resellerBroker", false);
                                }
                                addBankCardToggleModal();
                              }}
                              content=""
                              link=""
                            />
                          }
                        </Form>
                      </>
                    );
                  }}
                </Formik>
              )}
            </ProfileType>           
          </div>
          
          <div></div>
          <div className="section-wrapper"  style={{ "margin-top": "50px" }}>
           <UpgradeGuestSubscription />
          </div>
          <div></div>
          <div className="section-wrapper"  style={{ "margin-top": "50px" }}>
            <div class="community-details-header seller">
              <div class="community-name">
                <h4>
                  {pageLanguageContents?.Arrow_Payment[0]?.Title}
                </h4>
              </div>
            </div>
            <div className="paymenttab-section">
              <PaymentTabs
                pageData={pageData}
                pageLanguageContents={pageLanguageContents}
                callBackFetchApi={() => {
                  callBackFetch();
                }}
                defaultPaymentCallBack={(id) => {
                  defaultPaymentAPI(id)
                }}
              />
            </div>
          </div> 
          </>:
          <>
          <div></div>
          <div className="section-wrapper">
            <div class="community-details-header seller">
              <div class="community-name">
                <h4>
                  {pageLanguageContents?.Arrow_Payment[0]?.Title}
                </h4>
              </div>
            </div>
            <div className="paymenttab-section">
              <PaymentTabs
                pageData={pageData}
                pageLanguageContents={pageLanguageContents}
                callBackFetchApi={() => {
                  callBackFetch();
                }}
                defaultPaymentCallBack={(id) => {
                  defaultPaymentAPI(id)
                }}
              />
            </div>
          </div> 

          <div></div> <div
            ref={myRef}
            className="section-wrapper"    
            style={{ "margin-top": "50px" }}       
          >
            <div class="community-details-header seller">
              <div class="community-name" ref={props?.scrollToProfileSection}>
                <h4>
                  Profile Type
                  {brokerAccount === "brokerAc" &&
                    iIcon(
                      "Brokers and asset-based buyers and sellers will need to maintain separate accounts. If you would like to register as an asset-based buyer, seller, or both, please request a new account by completing a new registration form."
                    )}
                  {brokerAccount !== "brokerAc" && pageData?.userDetails?.userRole !== 'GUEST' &&
                    iIcon(
                      "This section shows if you are registered as a buyer, seller, or both. To register as an additional account type, please check the box to complete setup. If you wish to register as a broker, please request a new account by completing a new registration form."
                    )}
                    {pageData?.userDetails?.userRole === 'GUEST' &&
                    iIcon(
                      "This account is registered as a guest. Upgrade to a member in the Manage Subscription section below."
                    )}
                </h4>
              </div>
            </div>
            <ProfileType>
              {pageData && (
                <Formik
                  initialValues={getInitialValues(pageData)}
                  onSubmit={(values) => { }}
                >
                  {(props) => {
                    const {
                      isValid,
                      dirty,
                      values,
                      errors,
                      touched,
                      setFieldValue,
                    } = props;
                    return (
                      <>
                        <Form>
                          <div style={{ display: "flex", "flex-wrap": "wrap" }}>
                            {pageData?.userDetails?.userRole !== 'BROKER' && (
                              <>{pageData?.userDetails?.userRole !== 'GUEST' ? <>
                                <div style={{ "margin-right": "20px" }}>
                                  <CheckboxInput
                                    name="buyerChk"
                                    label="Buyer"
                                    disabled={pageData?.userDetails?.userRole === 'BUYER' || pageData?.userDetails?.userRole === 'BUYSELL' || pageData?.userDetails?.locationType === 'DEP' || pageData?.userDetails?.locationType === 'INDEPENDENT'}
                                    handleSelect={(name, label, e) => {
                                      setSelectProfile("Buyer");
                                      addDebitCreditToggleModal();
                                    }}
                                  />
                                </div>
                                <div style={{ "margin-right": "20px" }}>
                                  <CheckboxInput
                                    name="sellerChk"
                                    label="Seller"
                                    disabled={pageData?.userDetails?.userRole === 'SELLER' || pageData?.userDetails?.userRole === 'BUYSELL' || pageData?.userDetails?.locationType === 'DEP' || pageData?.userDetails?.locationType === 'INDEPENDENT'}
                                    handleSelect={(name, label, e) => {
                                      addBankCardToggleModal();
                                      setSelectProfile("Seller");
                                    }}
                                  />
                                </div>
                              </> : <>
                                <div style={{ "margin-right": "20px" }}>
                                  <CheckboxInput
                                    name="buyerChk"
                                    // label="Guest Member"
                                    label="Guest"
                                    disabled={true}
                                    checked={true}
                                    handleSelect={(name, label, e) => {
                                    }}
                                  />
                                </div>
                              </>}

                              </>
                            )}
                            {pageData?.userDetails?.userRole === 'BROKER' && (
                              <div style={{ "margin-right": "20px" }}>
                                <CheckboxInput
                                  name="resellerBroker"
                                  label="Broker"
                                  disabled={true}
                                  handleSelect={(name, label, e) => {
                                    setBokerAcState(true);
                                    setSelectProfile("Broker");
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          {addDebitCreditCardmodal &&
                            <DebitCreditCard
                              isOpen={addDebitCreditCardmodal}
                              toggle={addDebitCreditToggleModal}
                              modalType='sellerToBothBuySellConversion'
                              pageData={pageData}
                              type="profile"
                              onClickHander={(val) => {
                                if (val === "close") {
                                  if (selectProfile === "Buyer")
                                    setFieldValue("buyerChk", false);

                                  if (selectProfile === "Seller")
                                    setFieldValue("sellerChk", false);

                                  if (selectProfile === "Broker")
                                    setFieldValue("resellerBroker", false);
                                }
                                callBackFetch()
                                addDebitCreditToggleModal();
                              }}
                            />
                          }
                          {addBankCardmodal &&
                            <BankACForm
                              isOpen={addBankCardmodal}
                              modalType='buyerToBothBuySellConversion'
                              toggle={addBankCardToggleModal}
                              title=""
                              pageData={pageData}
                              callBackModal={() => {
                                addBankCardToggleModal();
                              }}
                              onClickHander={(val) => {
                                callBackFetch()
                                if (val === "close") {
                                  if (selectProfile === "Buyer")
                                    setFieldValue("buyerChk", false);

                                  if (selectProfile === "Seller")
                                    setFieldValue("sellerChk", false);

                                  if (selectProfile === "Broker")
                                    setFieldValue("resellerBroker", false);
                                }
                                addBankCardToggleModal();
                              }}
                              content=""
                              link=""
                            />
                          }
                        </Form>
                      </>
                    );
                  }}
                </Formik>
              )}
            </ProfileType>           
          </div>
          </>}

          <AlertModal
              isOpen={modal}
              toggle={toggleModal}
              title=""
              content={modalContent}
              link={modalLink}
              alertType=''
              callBackAlert={() => {
              }}
            />
        </Wrapper>
      </Container>
    </>
  );
};

export default PaymentDetail;

const Wrapper = styled.div`
  margin: 20px auto;
  display: grid;
  grid-template-columns: 237px 1fr;
  grid-column-gap: 46px;
  .section-wrapper {
    border-radius: 10px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.16);
    padding: 15px 28px;
  }
  @media (max-width: 1250px) {
    grid-template-columns: 237px 1fr;
  }
  @media (max-width: 1250px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;
const Container = styled.div`
  max-width: 1407px;
  margin: 0 auto;
  padding: 15px 10px;
  @media (max-width: 1250px) {
    padding: 15px;
  }
`;
const HeadingSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
  > div {
    width: 19px;
    height: 4px;
    border-radius: 2.8px;
    background-color: #00b3ff;
    margin: 0 8px;
  }
  h3 {
    color: #00b3ff;
    font-size: 22px;
  }
`;
const Heading = styled.div`
  display: flex;
  align-items: center;
  color: #00b3ff;
  justify-content: center;
  margin-bottom: 10px;
  > div {
    margin: 0 9px;
    width: 19px;
    height: 4px;
    border-radius: 2.8px;
    background-color: #00b3ff;
  }
  > h3 {
    font-size: 22px;
  }
`;
const HeaderDetail = styled.div`
  padding: 0 20px 20px;
  background-color: #fff;
  /* display: flex; */
  justify-content: space-between;
  /* flex-wrap: wrap; */
  border-bottom: solid 1px #87cdf1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(178px, 1fr));

  > div {
    padding: 0 10px;
  }

  h6 {
    font-size: 18px;
    color: #292929;
    line-height: 1.67;
    font-family: "latobold";
  }
  p {
    font-size: 14px;
    line-height: 1.79;
    color: #29292996;
  }
  @media (max-width: 767px) {
    display: grid;
    grid-template-columns: 1fr;
    padding: 0;
    > div {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
      padding: 0;
    }
    h6 {
      font-size: 14px;
    }
  }
`;
const ProfileType = styled.div`
  /* padding: 0 20px; */
`;
